import React from 'react';
import {
  FaHtml5,
  FaCss3Alt,
  FaGithub,
  FaNodeJs,
  FaReact,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import { SiJavascript } from 'react-icons/si';
import { DiMongodb } from 'react-icons/di';
import { TbBrandReactNative } from 'react-icons/tb';
import { Button, Chip } from '@mui/material';

export default function ProjectCard({
  isFeatured,
  isDark,
  projectImg,
  title,
  githubRep,
  liveLink,
  projDesc,
  isHtml,
  isCss,
  isNodejs,
  isJs,
  isReact,
  isMongo,
  isReactnative,
}) {
  return (
    <div>
      <div
        className={
          isDark
            ? 'project-listing-container dark'
            : 'project-listing-container'
        }
      >
        {isDark ? (
          <>
            <div className="img-container-s">
              <img
                src="./images/light.png"
                className="coding"
                alt="about-img"
              />
            </div>
            <div className="img-container-md">
              <img
                src={projectImg}
                className="coding box-shadow"
                alt="about-img"
              />
            </div>
            <div className="mt-05">
              {isFeatured && <Chip label="Featured Project" color="primary" />}
              <div className="head-1">
                <span>{title}</span>
              </div>
              <p className="head-2 width-md">
                <i>{projDesc}</i>
              </p>
              <div className="tech-stack-wrapper">
                {isHtml && (
                  <span title="HTML">
                    <FaHtml5 size={40} />
                  </span>
                )}
                {isCss && (
                  <span title="CSS">
                    <FaCss3Alt size={40} />
                  </span>
                )}
                {isNodejs && (
                  <span title="NodeJS">
                    <FaNodeJs size={40} />
                  </span>
                )}
                {isJs && (
                  <span title="Javascript">
                    <SiJavascript size={40} />
                  </span>
                )}
                {isReact && (
                  <span title="ReactJS">
                    <FaReact size={40} />
                  </span>
                )}
                {isMongo && (
                  <span title="MongoDB">
                    <DiMongodb size={40} />
                  </span>
                )}
                {isReactnative && (
                  <span title="React Native">
                    <TbBrandReactNative size={40} />
                  </span>
                )}
              </div>
              <span className="project-links">
                <a
                  href={githubRep}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="a-link"
                >
                  <Button variant="contained" color="primary">
                    <FaGithub size={20} />
                  </Button>
                </a>
                {liveLink && (
                  <a
                    href={liveLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="a-link"
                  >
                    <Button variant="contained" color="primary">
                      <FaExternalLinkAlt size={20} />
                    </Button>
                  </a>
                )}
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="mt-05">
              {isFeatured && <Chip label="Featured Project" color="primary" />}
              <div className="head-1 flex">
                <span>{title}</span>
              </div>
              <p className="head-2 width-md">
                <i>{projDesc}</i>
              </p>
              <div className="tech-stack-wrapper">
                {isHtml && (
                  <span title="HTML">
                    <FaHtml5 size={40} />
                  </span>
                )}
                {isCss && (
                  <span title="CSS">
                    <FaCss3Alt size={40} />
                  </span>
                )}
                {isNodejs && (
                  <span title="NodeJS">
                    <FaNodeJs size={40} />
                  </span>
                )}
                {isJs && (
                  <span title="Javascript">
                    <SiJavascript size={40} />
                  </span>
                )}
                {isReact && (
                  <span title="ReactJS">
                    <FaReact size={40} />
                  </span>
                )}
                {isMongo && (
                  <span title="MongoDB">
                    <DiMongodb size={40} />
                  </span>
                )}
                {isReactnative && (
                  <span title="React Native">
                    <TbBrandReactNative size={40} />
                  </span>
                )}
              </div>
              <span className="project-links">
                <a
                  href={githubRep}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="a-link"
                >
                  <Button variant="contained" color="primary">
                    <FaGithub size={20} />
                  </Button>
                </a>
                <a
                  href={liveLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="a-link"
                >
                  <Button variant="contained" color="primary">
                    <FaExternalLinkAlt size={20} />
                  </Button>
                </a>
              </span>
            </div>
            <div className="img-container-md">
              <img
                src={projectImg}
                className="coding box-shadow"
                alt="about-img"
              />
            </div>
            <div className="img-container-s">
              <img
                src="./images/light.png"
                className="coding"
                alt="about-img"
              />
            </div>
          </>
        )}
      </div>
      <div className="flex-center">
        <img
          src="./images/divider.png"
          className="divider-line coding"
          alt="divider-img"
        />
      </div>
    </div>
  );
}
